<template>
    <div class="features-header py-9 px-10 lighten-1">
        <v-row align="center" justify="center">
            <v-col cols="12" class="d-flex justify-space-between">
                <div class="pt-5">
                    <h1 class="white--text">Olá {{userName}},</h1>
                    <p class="white--text">Estas são suas faturas em aberto</p>
                    <h4 v-if="isShowSignOut" @click="signOut" @click.right="signOut" class="grey--text">SAIR</h4>
                </div>
                <div>
                    <img src="@/assets/tely_logo.png" alt="">
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import {signOut} from "@/controllers/user.controller"
export default {
    props: {
        name: String,
        isShowSignOut: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            signOut
        }
    },
    computed: {
        userName () {
        return this.name.split(' ')[0]
        },
    }
}
</script>

<style scoped>
.features-header {
    width: 100%;
    box-shadow: 0px 6px 0px rgba(255, 255, 255, 0.4), 0px 0px 32px rgba(35, 41, 46, 0.2);
    backdrop-filter: blur(24px);
    border-radius: 0px 0px 0px 64px;
    background-color: #01DCFC !important;
}

.white--text{
    color: #1A237E !important;
}

.grey--text {
    color: #E8EAF6 !important;
}
</style>